<template>
  <div class="login">
    <v-form @reset.prevent="cancel" @submit.prevent="login" ref="form" v-model="valid">
      <v-card class="mx-auto mt-8 pa-4" max-width="400" outlined>
        <v-card-title class="justify-center pa-2">
          <img :src="logo" alt="Kahu Smart Workplace" class="pa-5 logo">
        </v-card-title>
        <v-alert color="error" dark dense tile v-if="loginError">{{ errorMessage }}</v-alert>
        <v-card-text>
          <v-text-field
              @focus="keyboard.show = true"
              @blur="keyboard.show = false"
              :rules="email.rules"
              autocomplete="email"
              label="Email"
              required
              clearable
              type="email"
              v-model="email.value"/>
          <v-text-field
              @focus="keyboard.show = true"
              @blur="keyboard.show = false"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="password.rules"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              autocomplete="current-password"
              clearable
              label="Password"
              required
              v-model="password.value"/>
          <v-switch label="Use virtual keyboard" v-model="keyboard.enabled" color="primary"/>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn :disabled="!valid" :progress="working" color="secondary" type="submit">Log in</v-btn>
          <v-btn v-if="updateAvailable" color="secondary" @click="updateApp">Update</v-btn>
        </v-card-actions>
      </v-card>
      <about-line class="py-2"/>
    </v-form>

    <simple-keyboard v-if="keyboard.enabled && keyboard.show"/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import SimpleKeyboard from '../components/SimpleKeyboard';
import AboutLine from '@/components/AboutLine';

export default {
  name: 'Login',
  components: {AboutLine, SimpleKeyboard},
  data() {
    return {
      email: {
        rules: this.textRules('Email'),
        value: ''
      },
      password: {
        rules: this.textRules('Password'),
        value: ''
      },
      valid: false,
      working: false,
      loginError: null,
      showPassword: false,
      keyboard: {
        enabled: false,
        show: false
      }
    };
  },
  computed: {
    ...mapState('serviceWorker', ['updated']),
    ...mapGetters('auth', ['authUser']),
    updateAvailable() {
      return this.updated;
    },
    logo() {
      return require('../assets/Kahu-tagline.svg?as-is');
    },
    errorMessage() {
      if (!this.loginError) {
        return false;
      }

      switch (this.loginError.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          return 'Incorrect email or password';
      }
      return this.loginError.message || `${this.loginError}`;
    },
    force() {
      return this.$route.params.force === 'true';
    }
  },
  watch: {
    authUser: {
      handler(authUser) {
        if (!this.force && Object.keys(authUser).length !== 0) {
          this.nextStep();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('serviceWorker', ['reload', 'update']),
    ...mapActions('auth', ['signOut', 'signIn']),
    async updateApp() {
      // upgrade the service worker and refresh the page
      await this.reload();
      window.location.reload();
    },
    login() {
      this.working = true;
      this.loginError = null;
      this.signIn({
        email: this.email.value,
        password: this.password.value
      })
          .then(() => this.redirect())
          .catch(err => this.loginError = err)
          .finally(() => this.working = false);
    },
    textRules(name) {
      return [
        v => !!v || `${name} is required`,
        v => v.trim().length > 0 || `${name} cannot be empty`
      ];
    },
    nextStep() {
      this.$router.push({name: 'home'})
          .catch(() => this.$logger.error('aborted'));
    }
  }
};
</script>

<style scoped>
  .login {
    height: 800px;
    width: 1280px;
  }

  .logo {
    max-height: 150px;
  }
</style>
